import React, { Fragment, useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Loading from "../../../../Common/Components/Loading";
import {
  FormSubmitSite,
  GetGenralData,
  ShowData,
  checkEmpty,
} from "../Components/Services";
import BoxShadow from "../../../../Common/Components/BoxShadow";

function Create() {
  const [state, setstate] = useState({
    loading: true,
    data: null,
  });

  const [form, setForm] = useState({
    force_update: false,
    app_version: "",
  });

  const handler = () => {
    setstate({ ...state, loading: true });
    GetGenralData().then(data => {
      setstate({
        loading: false,
        data: data,
      });
    });
  };
  const submit = () => {
    setstate({ ...state, loading: true });
    FormSubmitSite(form).then(() => {
      setstate({ ...state, loading: false });
      handler();
    });
  };
  useEffect(() => {
    handler();
  }, []);

  const renderData = force_update => {
    switch (force_update) {
      case true:
      case "true":
        return "نسخه اجباری";
      case false:
      case "false":
        return "نسخه غیر اجباری";
    }
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | تنظیمات نسخه اپ</title>
      </Helmet>
      <BoxShadow
        style={{
          margin: "0",
        }}
      >
        <div className="row">
          <h3>تنظیمات نسخه اپ</h3>
        </div>
        <div className="row">
          {state.loading ? (
            <Loading count={1} col={12} height={300} />
          ) : (
            <Fragment>
              <div className="col-12 border-bottom">
                <div className="d-flex ">
                  <h6>آخرین نسخه : </h6>
                  <h6>{ShowData(state.data, "app_version")}</h6>
                </div>
                <div className="d-flex justify-content-between">
                  <h6>{renderData(ShowData(state.data, "force_update"))}</h6>
                </div>
              </div>

              <div className="col-6">
                <div className="mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    شماره نسخه
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    defaultValue={state.data.app_version}
                    onChange={({ target: { value } }) => {
                      setForm({
                        ...form,
                        app_version: value,
                      });
                    }}
                  />
                </div>
                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="exampleCheck1"
                    checked={state.data.force_update}
                    onClick={() => {
                      setForm({
                        ...form,
                        force_update: true,
                      });
                    }}
                  />
                  <label className="form-check-label" htmlFor="exampleCheck1">
                    نسخه اجباری
                  </label>
                </div>
                <button onClick={submit} className="btn btn-primary">
                  {state.loading ? "در حال ارسال" : "ارسال"}
                </button>
              </div>
            </Fragment>
          )}
        </div>
      </BoxShadow>
    </Fragment>
  );
}

export default Create;
